import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

const NAV = [
  { to: "/shop", label: "Shop Kits" },
  { to: "/accessories", label: "Accessories" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-ink border-t border-black/10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-16 pb-8">
        <div className="grid gap-12 md:grid-cols-12">
          <Reveal className="md:col-span-5">
            <p className="eyebrow mb-4 !text-zinc-400">Auckland E-Kits</p>
            <p className="max-w-sm text-sm leading-relaxed text-zinc-400">
              Premium e-bike conversion kits, configured your way and shipped
              NZ-wide from Auckland. Order online, we confirm stock and invoice
              you directly — $170 covers shipping to your door or Auckland
              pickup; installation is $200 flat.
            </p>
            <Link
              to="/contact"
              data-testid="footer-contact-link"
              className="mt-6 inline-block rounded-[3px] border border-white/20 px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] text-white hover:border-volt hover:text-volt transition-colors duration-200"
            >
              Talk to us
            </Link>
          </Reveal>
          <Reveal delay={0.1} className="md:col-span-3">
            <p className="eyebrow mb-4 !text-zinc-400">Navigate</p>
            <ul className="space-y-2.5">
              {NAV.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.to.slice(1).replace("/", "-")}`}
                    className="text-sm text-zinc-400 hover:text-volt transition-colors duration-200"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.15} className="md:col-span-4">
            <p className="eyebrow mb-4 !text-zinc-400">Power Your Ride.</p>
            <p className="text-sm leading-relaxed text-zinc-500">
              NZ based. Quality components. Torque arms included with every
              combo kit. No card needed online — we invoice you manually after
              confirming stock.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1} className="mt-16 select-none overflow-hidden">
          <p
            className="font-display font-black leading-[0.85] tracking-tight whitespace-nowrap"
            style={{ fontSize: "clamp(3rem, 10vw, 10rem)" }}
            aria-hidden="true"
          >
            AKL <span className="text-outline-volt">E-KITS</span>
          </p>
        </Reveal>

        <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-white/10 pt-6">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">
            © {year} Auckland E-Kits
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">
            Built in Auckland, NZ
          </p>
        </div>
      </div>
    </footer>
  );
}
